import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { map, tap, catchError } from 'rxjs/operators';
import { empty, throwError, of } from 'rxjs';

import { environment } from '../../../environments/environment';
import { ITenantsApi, Tenant, User, IUsersResult, Subscription, Plan } from 'app/tenants/tenant.model';


@Injectable()
export class PlansService {

    private baseUrl: string;
    private apiBaseUrl: string;
    private adminApiBaseUrl: string;
    /**
    * Constructor
    * @param {HttpClient} _httpClient
    */
    constructor(private httpClient: HttpClient) {
        this.baseUrl = environment.backEnd;
        this.apiBaseUrl = this.baseUrl + '/api/plans';
        this.adminApiBaseUrl = this.baseUrl + '/api/planAdmin';
    }

    getPlans(): Observable<Plan[]> {
        return this.httpClient
            .get<Plan[]>(`${this.apiBaseUrl}`);
    }
    getPlanByName(name: string): Observable<Plan> {
        return this.httpClient
            .get<Plan>(`${this.apiBaseUrl}/name/${name}`);
    }

    getPlanByCode(planCode: string): Observable<Plan> {
        return this.httpClient
            .get<Plan>(`${this.apiBaseUrl}/code/${planCode}`);
    }

    getPlanById(id: string): Observable<Plan> {
        return this.httpClient
              .get<Plan>(`${this.apiBaseUrl}/${id}`);
    }

    getAdminPlans(): Observable<Plan[]> {
        return this.httpClient
            .get<Plan[]>(this.adminApiBaseUrl);
    }

    getAdminPlanById(id: string): Observable<Plan> {
        return this.httpClient
            .get<Plan>(`${this.adminApiBaseUrl}/${id}`);
    }

    updateAdminPlan(id: string, plan: Plan): Observable<Plan> {
        return this.httpClient
            .put<Plan>(`${this.adminApiBaseUrl}/${id}`, plan);
    }

}
